import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { TEXT } from "theme/texts";

type propsTabview = {
  data: {
    label: string;
    value: string;
  }[];
  value: string;
  onClick: (value: string) => void;
  wrapperstyle?: string;
};

const Tabview = ({ data, value, onClick, wrapperstyle }: propsTabview) => {
  return (
    <TabViewWrapper>
      {data.map((element) => {
        return (
          <StyledNavLink
            active={element.value === value}
            onClick={() => onClick(element.value)}
          >
            <TEXT.SmallHeader
              padding={'1rem'}
              fontWeight={500}
              style={{ whiteSpace: "nowrap", fontSize: "1rem" }}
            >
              {element.label}
            </TEXT.SmallHeader>
            <div className="_bottom" />
          </StyledNavLink>
        );
      })}
    </TabViewWrapper>
  );
};

const StyledNavLink = styled.div<{ active?: boolean }>`
  cursor: pointer;
  color: ${({ active, theme }) => (active ? theme.body : theme.disabledVar2)};
  text-decoration: none;
  align-items: center;
  ${({ active, theme }) =>
    active
      ? `
          color:${theme.body};
    ._bottom {
      width: auto;
      height: 4px;
      background: ${theme.btnPrimary};
     }`
      : ""}
`;

const TabViewWrapper = styled.div`
  display: flex;
  gap: 2rem;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
  /* margin-left: 126px; */
  ${({ theme }) => theme.mediaWidth.upToMedium`
   gap: 0.4rem;
  `}
`;

export default Tabview;
